/**
 * Funnel-forward back button (storefront).
 * Home and other non-PDP pages → /products/serum (URL params kept).
 * Quiz Back leads to the PDP.
 * PDP / cart back → secure subscribe checkout (/ss). Never Shopify /checkout.
 * Skips account, manage, and already-on-checkout paths.
 */
(function () {
  try {
    var cfg = window.HP_FUNNEL_BACK || {};
    var path = (location.pathname || "/").replace(/\/+$/, "") || "/";

    if (
      /^\/(account|orders|challenge|customer_authentication)/i.test(path) ||
      /^\/checkouts\//i.test(path) ||
      path === "/checkout" ||
      path.indexOf("/manage") === 0
    ) {
      return;
    }

    var isPdp =
      path === "/serum" ||
      path === "/products/serum" ||
      /^\/products\//i.test(path);
    var isCart = path === "/cart";
    var toCheckout = isPdp || isCart;
    var serumUrl = cfg.serumUrl || "/products/serum";

    for (var i = 0; i < 10; i++) {
      history.pushState({ hpFunnel: 1 }, "", location.href);
    }

    window.addEventListener("popstate", function () {
      if (toCheckout) {
        goCheckout();
      } else {
        var dest = new URL(serumUrl, location.origin);
        new URLSearchParams(location.search).forEach(function (value, key) {
          if (!dest.searchParams.has(key)) dest.searchParams.set(key, value);
        });
        location.replace(dest.toString());
      }
    });
  } catch (e) {}

  function goCheckout() {
    var dest = new URL("https://secure.getherpart.com/ss");
    var src = new URLSearchParams(location.search);
    src.forEach(function (value, key) {
      if (!dest.searchParams.has(key)) dest.searchParams.set(key, value);
    });
    // F3 tracking: tag Back-redirect entries so the checkout Worker doesn't count them as checkout starts
    // (and skips its Whop page-load add_to_cart). Redirect behaviour itself is unchanged.
    dest.searchParams.set("hp_nav", "back");
    location.replace(dest.toString());
  }
})();
